// USA
export const locale = {
  lang: 'en',
  data: {
    Create: 'Create',
    Update: 'Update',
    View: 'View',
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    OPEN_IN_NEW_TAP: "Open in new tap",
    DASHBAORD: {
      FASTLINKS: 'Fast Links',
    },
    DASHBOARD: {
      LOADING: 'Loading...',
      FILTERS: {
        TIME_FILTER: 'Time Filter',
        SELECT_TIME: 'Select Time Period',
        LAST_7_DAYS: 'Last 7 Days',
        LAST_MONTH: 'Last Month',
        LAST_YEAR: 'Last Year'
      },
      STATUS: {
        ACTIVE: 'Active',
        PENDING: 'Pending',
        INACTIVE: 'Inactive',
        CANCELLED: 'Cancelled',
        TRIAL: 'Trial',
        EXPIRED: 'Expired',
        PAID: 'Paid',
        FAILED: 'Failed',
      },
      STATS: {
        TOTAL_TENANTS: 'Total Tenants',
        TOTAL_TENANTS_DESC: 'Total number of tenants in the system',
        TOTAL_SUBSCRIPTIONS: 'Total Subscriptions',
        TOTAL_SUBSCRIPTIONS_DESC: 'Total number of subscriptions',
        TOTAL_PACKAGES: 'Total Packages',
        TOTAL_PACKAGES_DESC: 'Number of available packages',
        TOTAL_USERS: 'Total Users',
        TOTAL_USERS_DESC: 'Total number of users'
      },
      CHARTS: {
        SUBSCRIPTIONS_BY_STATUS: 'Subscriptions by Status',
        SUBSCRIPTIONS_BY_PACKAGE: 'Subscriptions by Package',
        SUBSCRIPTIONS_BY_PACKAGE_AND_STATUS: 'Subscriptions by Package and Status',
        SUBSCRIPTIONS_BY_PACKAGE_AND_STATUS_DESC: 'Breakdown of subscription states within each package',
        STATUS_OVERVIEW: 'Status Overview',
        PACKAGE_RANKING: 'Package Ranking',
        PACKAGE_STATUS_INSIGHTS: 'Package Status Insights',
        GROWTH_TREND: 'Growth Trend',
        SUBSCRIPTIONS_GROWTH: 'Subscriptions Growth Over Time',
        SUBSCRIPTIONS_GROWTH_DESC: 'Number of new subscriptions during the selected period',
        SUBSCRIPTIONS_COUNT: 'Subscriptions Count',
        TOTAL: 'Total',
      },
      TABLES: {
        RECENT_SUBSCRIPTIONS: 'Recent Subscriptions',
        RECENT_SUBSCRIPTIONS_DESC: 'Last 10 subscriptions in the system',
        RECENT_TENANTS: 'Active Tenants',
        RECENT_TENANTS_DESC: 'Last 10 active tenants',
        NO_DATA: 'No data available'
      },
      ERRORS: {
        ERROR: 'Error',
        LOAD_STATISTICS: 'An error occurred while loading statistics'
      }
    },
    PAYMENTS: {
      PAYMENT_ID: 'Payment ID',
      TENANT_NAME: 'Tenant Name',
      DATE: 'Payment Date',
      NOTES: 'Notes',
      AMOUNT: 'Amount',
      METHOD: 'Payment Method',
      STATUS: 'Status',
      CREATE: 'Create Payment',
      UPDATE: 'Update Payment',
      TITLE: 'Payment',
      LABEL: {
        TENANT: 'Tenant',
        PACKAGE: 'Subscription',
        AMOUNT: 'Amount',
        METHOD: 'Payment Method',
        NOTES: 'Notes'
      },
      PLACEHOLDER: {
        TENANT: '`Select `Tenant',
        PACKAGE: 'Select Subscription',
        AMOUNT: 'Enter amount',
        METHOD: 'Select payment method',
        NOTES: 'Enter notes (optional)'
      },
      VALIDATION: {
        TENANT: 'Tenant is required',
        PACKAGE: 'Subscription is required',
        AMOUNT: 'Amount is required',
        METHOD: 'Payment method is required',
      }
    },
    subscriptions: {
      title: 'Subscriptions',
      create: 'Create Subscription',
      update: 'Update Subscription',
      view: 'View Subscription',
      loading: 'Loading subscriptions...',
      details: 'Subscription Details',
      tenantName: 'Tenant Name',
      package: 'Package',
      subscriptionStatus: 'Subscription Status',
      startDate: 'Start Date',
      endDate: 'End Date',
      billingCycle: 'Billing Cycle',
      renewal: 'Renewal',
      isActive: 'Is Active',
      extend: 'Extend',
      EXTEND: {
        TITLE: 'Extend subscription',
        NEW_END_DATE_LABEL: 'New end date',
        PLACEHOLDER: 'Select new end date',
        SUBMIT: 'Confirm extension',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
        VALIDATION: {
          REQUIRED: 'New end date is required',
          NOT_AFTER_CURRENT: 'The date must be after the current subscription end date',
        },
      },
      CUSTOMIZE: {
        TITLE: 'Customize subscription',
        BUTTON: 'Customize subscription',
        DESCRIPTION: 'Adjust the limits below for this subscription. Changes apply after you save and confirm.',
        ENABLE_ON_CREATE: 'Customize subscription features',
        SELECT_PACKAGE_FIRST: 'Select a package first to load customizable features.',
        NO_FEATURES: 'This package has no customizable features.',
        IS_CUSTOM_BADGE: 'Custom subscription',
        VALUE_HINT: 'Allowed value from {{min}} to {{max}}',
        SUBMIT: 'Save customization',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
        VALIDATION: {
          REQUIRED: 'This field is required',
        },
      },
      activeToggle: 'Activate / deactivate',
      activateSubscription: 'Activate',
      deactivateSubscription: 'Deactivate',
      zatca: 'ZATCA',
      LABEL: {
        TENANT: 'Tenant',
        PACKAGE: 'Package',
        AUTO_RENEWAL: 'Auto Renewal',
        IS_ZATKA_ENABLED: 'Is Zatka Enabled',
        PAYMENT_PERIOD: 'Payment Period',
        IS_ACTIVE: 'Is Active'
      },
      PLACEHOLDER: {
        TENANT: 'Select Tenant',
        PACKAGE: 'Select Package',
        AUTO_RENEWAL: 'Enable Auto Renewal',
        IS_ZATKA_ENABLED: 'Enable Zatka',
        PAYMENT_PERIOD: 'Select Payment Period',
        IS_ACTIVE: 'Select Status'
      },
      VALIDATION: {
        TENANT: 'Tenant is required',
        PACKAGE: 'Package is required',
        AUTO_RENEWAL: 'Auto Renewal value is required',
        IS_ZATKA_ENABLED: 'Zatka status is required',
        PAYMENT_PERIOD: 'Payment period is required',
        IS_ACTIVE: 'Status is required'
      }
    },
    "TENANT": {
      "TITLE": "Tenants",
      "CREATE": "Create Tenant",
      "UPDATE": "Update Tenant",
      "DELETE": "Delete Tenant",
      "VIEW": "View Tenant",
      "LOADING": "Loading tenants...",
      "DETAILS": "Tenant Details",
      "LABEL": {
        "COMPANY_NAME": "Company Name",
        "COMPANY_NAME_AR": "Company Name (Arabic)",
        "COMPANY_NAME_EN": "Company Name (English)",
        "EMAIL": "Email Address",
        "PHONE": "Phone Number",
        "SUBSCRIPTION_PLAN": "Subscription Plan",
        "SUBSCRIPTION_STATUS": "Subscription Status",
        "IS_ACTIVE": "Is Active"
      },
      "PLACEHOLDER": {
        "COMPANY_NAME_AR": "Enter Company Name (Arabic)",
        "COMPANY_NAME_EN": "Enter Company Name (English)",
        "EMAIL": "Enter Email Address",
        "PHONE": "Enter Phone Number",
        "SUBSCRIPTION_PLAN": "Enter Subscription Plan"
      },
      "VALIDATION": {
        "COMPANY_NAME_AR": "Company Name (Arabic) is required",
        "COMPANY_NAME_EN": "Company Name (English) is required",
        "EMAIL": "Email Address is required",
        "PHONE": "Phone Number is required",
        "SUBSCRIPTION_PLAN": "Subscription Plan is required"
      },
      "ACTIONS": "Actions"
    },
    FILTER: {
      LABELS: {
        EQUAL: 'Equal',
        NOT_EQUAL: 'Not equal',
        LESS_THAN: 'Less than',
        LESS_THAN_OR_EQUAL: 'Less than or equal',
        GREATER_THAN: 'Greater than',
        GREATER_THAN_OR_EQUAL: 'Greater than or equal',
        STARTSWITH: 'Starts with',
        ENDSWITH: 'Ends with',
        CONTAINS: 'Contains',
      },
      PLACEHOLDER: {
        COLUMN: "Choose a column to filter",
        VALUE: "Filter by value",
        OPTION: "Select an option",
        OPERATOR: "Select an operator",
      },
      BTN: {
        APPLY: "Apply",
        RESET: 'Reset',
      }
    },
    AccountNature: {
      DEBIT: "Debit",
      CREDIT: "Credit",
      DEBIT_CREDIT: "Debit Credit"
    },
    ACTIONS: {
      RESET: "Reset",
      APPLY: "Apply",
      ADD_RETURN: 'Add Return',
      PRINT: "print"
    },
    AUTHS: {
      NEXT: 'Next',
      RESET_PASSWORD: 'Reset password',
      CHANGE_PASSWORD: 'Change password',
      CURRENT_PASSWORD: 'Current password',
      NEW_PASSWORD: 'New password',
      CONFIRM_NEW_PASSWORD: 'Confirm new password',
      PASSWORDS_MUST_MATCH: 'Passwords must match',
      GO_BACK: 'Go back to',
      LOGOUT: 'Sign Out',
      LOGIN: {
        WELCOME_TO: 'Welcome to ',
        TABWEEB: 'Yasor',
        FULL_WELCOME: 'Welcome to Yasor',
        LOGINS: 'Login',
        LOG_IN: 'Log in',
        SIGN_IN: 'Sign in',
        SIGN_UP: 'Sign up',
        SIGN_GOOGLE: 'Sign in with Google',
        FORGET_PASSWORD: 'Forgot Password',
        BACK: 'Back',
        SIGNUP_MESSAGE: "Don't have an account?",
        SIGNIN_MESSAGE: 'Don have an account?',
        RECOVER_PASSWORD: 'Recover your password',
        SEND_EMAIL_FIRST: 'We have sent an email to ',
        SEND_EMAIL_LAST:
          'Please click on link received to verify your email and create your account. Or enter here the code. ',
        REGISTER: 'Register',
        FOOTER_COPYRIGHT: 'All rights reserved for tabweeb company',
        REMEMBER_PASSWORD: 'Remember password',
        TWO_FACTOR_TITLE: 'Two-step verification',
        TWO_FACTOR_DESC: 'Enter the 6-digit code from your authenticator app to complete sign-in.',
        TWO_FACTOR_VERIFYING: 'Verifying… You will be redirected shortly.',
        FORM: {
          PLACEHOLDER: {
            EMAIL: 'Username or email address',
            PASSWORD: 'Enter the password here',
          },
          LABEL: {
            EMAIL: 'Enter your username or email address',
            PASSWORD: 'Enter your password',
            NEW_PASSWORD: 'Enter the new password',
          },
          VALIDATION: {
            EMAIL:
              'This field is required and must be email or alphanumeric username',
            PASSWORD:
              'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one number or special character.',
            PASSWORD1:
              'Password is required',
          },
        },
      },
    },
    // start of intermediate account
    INTERMEDIATE_ACCOUNT: {
      LABELS: {
        NAME_AR: 'Name (Arabic)',
        NAME_EN: 'Name (English)',
        ACCOUNT: 'Account',
        BRANCH: 'Branch',
        SAVE: 'Save',
      },
      PLACEHOLDER: {
        BRANCH: 'Select Branch',
        ACCOUNT: 'Select Account',
      },
    },
    // end of intermediate account
    INVOICES: {
      GENERAL: {
        ADD_INVOICE: 'Add invoice',
        ADD_INVOICE_SALES: 'Add sales invoice',
        ADD_INVOICE_PURCHASES: 'Add purchases invoice',
        VIEW_INVOCES: 'View Invoices',
        VIEW_RETURN_INVOCES: 'View return invoices',
        VIEW_RETURN_INVOCE: 'View return invoice',
      },
      LABEL: {
        CUSTOMER: 'Customer',
        VENDOR: 'Vendor',
        DESCRIPTION: 'Description',
        PAYMENT_METHOD: 'Payment Method',
        SELECT_PRODUCTS: 'Select products',
      },
      PLACEHOLDERS: {
        INV_DATE: 'Select Invoice Date',
        CUSTOMER: 'select a customer',
        VENDOR: 'select a vendor',
        PAYMENT_METHOD: 'Select a payment method',
        DESCRIPTION: 'Add notes here',
        CHOOSE_PRODUCT: 'Choose a product',
      },
      VALIDATION: {
        INV_DATE: 'invoice date is required',
        CUSTOMER: 'customer is required',
        VENDOR: 'vendor is required',
        PAYMENT_METHOD: 'Payment required',
      },
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
    },
    GENERAL: {
      SUBMIT_BUTTON: 'Submit',
      SEARCH: 'Search ...',
      FILTER: 'Filter',
      IMPORT: 'Import',
      EXPORT: 'Export',
      ALL: 'All',
      ACTIVE: 'Active',
      UNACTIVE: 'Unactive',
    },
    REPORTS: {
      VALIDATION: {
        DATE_RANGE_INCOMPLETE: 'Please provide both from date and to date',
        DATE_RANGE_INVALID: 'From date must be before or equal to to date',
      },
      KPI: {
        TOTAL_REVENUE: 'Total Revenue',
        TOTAL_PAYMENTS: 'Total Payments',
        SUCCESSFUL_PAYMENTS: 'Successful Payments',
        PENDING_PAYMENTS: 'Pending Payments',
        TOTAL_SUBSCRIPTIONS: 'Total Subscriptions',
        BY_STATE: 'By State',
        TOTAL_USERS: 'Total Users',
        USERS_WITH_ROLES: 'Users with Roles',
      },
      LABEL: {
        PAYMENT_ID: 'Payment ID',
        AMOUNT: 'Amount',
        PAYMENT_DATE: 'Payment Date',
        STATUS: 'Status',
        METHOD: 'Payment Method',
        PACKAGE_NAME: 'Package Name',
        PAYMENT_PERIOD: 'Payment Period',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        PAYMENT_STATUS: 'Payment Status',
      },
    },
    PAGINATION: {
      DISPLAYING: 'Displaying',
      OF: 'of',
      RECORDS: 'records',
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    "ROLES": {
      "GENERAL": {
        "CREATE": "Create Role",
        "UPDATE": "Update Role",
        "LIST": "List Roles",
        "MAIN": "Roles",
        "SELECT_PERMISSIONS": "Select Permissions",
      },
      "CREATE": "Create Role",
      "TITLE": "Role",
      "LABEL": {
        "NAME_AR": "Role Name (Arabic)",
        "NAME": "Role Name",
        "DESCRIPTION": "Role Description",
        "NAME_EN": "Role Name (English)",
        "PERMISSIONS": "Permissions",
        "DESC": 'Description',
      },
      "PLACEHOLDER": {
        "NAME_AR": "Enter role name in Arabic",
        "NAME_EN": "Enter role name in English",
        "NAME": "Enter role name",
        "DESC": 'Enter a description',
      },
      "VALIDATION": {
        "NAME_AR": "Role name in Arabic is required",
        "NAME_EN": "Role name in English is required",
        "NAME": "Role name is required",
        "DESC": "Role description is required",
      },
      "BTN": {
        "RESET": "Reset"
      }
    },
    SIDEMENU: {
      HOME: 'Home',
      TENATNS: 'Tenants',
      PACKAGES: 'Packages',
      FEATURES: 'Features',
      ROLES: 'Roles',
      SUBSCRIPTIONS: 'Subscriptions',
      SUBSCRIPTIONS_PAYMENTS: 'Subscription Payments',
      PAYMENTS: 'Payments',
      SHIFTS: 'Shifts',
      SHIFTSCATEOGRY: 'Shifts Category',
      SHIFT_CATEGORIES: 'Shift Categories',
      SETTINGS: 'Settings',
      VERSIONS_MANAGEMENT: 'Versions Management',
      TWO_FACTOR_AUTH: 'Two-Factor Authentication',

      // old is here
      ACCOUNTING: 'Accounting',
      ACCOUNTS: 'Accounts',
      JOURNAL: 'Journal',
      ACCOUNT_STATEMENT: 'Account Statement',
      ACCOUNT_TYPES: 'Account Types',
      ACCOUNT_CATEGORIES: 'Account Categories',
      JOURNAL_TYPES: 'Journal Types',
      FINANCIAL_STATEMENTS: 'Financial Statements',

      SALES_RETURN_VIEW: 'View return invoice',

      SALES: 'Sales',
      CUSTOMERS: 'Customers',
      E_INVOICING: 'E-Invoicing',
      SALE_INVOICING: 'Sale Invoices',
      PURCHASE_INVOICING: 'Purchase Invoices',
      RETURN_SALES: 'Return Sales',

      PURCHASES: 'Purchases',
      VENDORS: 'Vendors',
      RETURN_PURCHASES: 'Return Purchases',

      STOCK: 'Stock',
      STOCK_MOVEMENT: 'Stock Movement',
      PRODUCTS: 'Products',
      PRODUCT_CATE: 'Product Categories',
      PRODUCT_BARCODES: 'Products Barcodes',

      FINANCE: 'Finance',
      TAX_RETURN: 'Tax Return',

      BALANCE_SHEET: 'Balance Sheet',
      TRAIL_BALANCE: 'Trail Balance',

      USER: 'User',
      USERS: 'Users',
      PROFILE: 'Profile',
      SECURITY_MONITORING: 'Security & Monitoring',
      LOGIN_HISTORY: 'Login History',
      AUDIT_TRAIL: 'Audit Trail',

      REPORTS: 'Reports',
      TENANT_REPORTS: 'Tenant Reports',
      USER_REPORTS: 'User Reports',
      SUBSCRIPTION_REPORTS: 'Subscription Reports',
      REVENUE_REPORTS: 'Revenue Reports',

      SALES_RETURN: 'Sales return',
      PURCHASES_RETURN: 'Purchases return',

      COMPANIES: 'Companies',
      COMPANY: 'Company',
      STORE: 'Store',
      CURRENCY: 'Currency',
      UNIT: 'Unit',
      PRICE_LEVEL: 'Price Level',
      TAX_CATEGORIES: 'Tax Categories',
      ROLE: 'Role',
      PERMISSION_ROLE: 'Permission Role',

      VIEW_INVOCE: 'View invoice',
      BRANCHES: "Branches",
      INTERMEDIATE_ACCOUNTS: "Intermediate Accounts",
    },

    TWO_FACTOR: {
      GENERAL: {
        TITLE: 'Two-Factor Authentication',
      },
      STATUS: {
        ENABLED: 'Enabled',
        DISABLED: 'Disabled',
      },
      STEP1: { SHORT: 'Enable' },
      STEP2: { SHORT: 'Scan QR' },
      STEP3: { SHORT: 'Verify' },
      STAGE1: {
        TITLE: 'Stage 1: Enable or disable',
        DESC: 'Control whether two-factor authentication is enabled for your account.',
        STATUS: 'Current status',
        TOGGLE: 'Enable two-factor authentication',
      },
      STAGE2: {
        TITLE: 'Stage 2: Set up authenticator app',
        DESC: 'Scan the QR code in your authenticator app, or enter the key manually.',
        QR_PLACEHOLDER_TITLE: 'QR code',
        QR_PLACEHOLDER: 'QR code will appear here after API integration',
        MANUAL_KEY: 'Manual setup key',
        APP_NAME: 'App name',
        MANUAL_KEY_HINT: 'Keep this key secret. Do not share it with anyone.',
      },
      STAGE3: {
        TITLE: 'Stage 3: Verify code',
        DESC: 'Enter the 6-digit code from your authenticator app to confirm setup.',
        USE_RECOVERY_CODE: 'Use recovery code',
        USE_OTP_CODE: 'Use app code',
        RECOVERY_CODE_LABEL: 'Recovery Code',
      },
      STAGE4: {
        TITLE: 'Stage 4: Recovery codes',
        DESC: 'Store recovery codes in a safe place. Use them if you lose access to your authenticator app.',
        PLACEHOLDER_ITEM: 'Recovery code will appear here after API integration',
        RECOVERY_CODE_PLACEHOLDER: 'Enter recovery code',
        NO_CODES_YET: 'No recovery codes shown. Click «Generate recovery codes» to create new codes and save them in a safe place.',
      },
      VALIDATION: {
        CODE: 'Enter a valid 6-digit code.',
        RECOVERY_CODE: 'Enter recovery code.',
      },
      BTN: {
        VERIFY: 'Verify',
        GENERATE_CODES: 'Generate recovery codes',
        DOWNLOAD_CODES: 'Download recovery codes',
      },
      MSG: {
        SETUP_SUCCESS: 'Two-factor authentication has been set up. Enter the code from your app to enable.',
        ENABLE_SUCCESS: 'Two-factor authentication is now enabled.',
        DISABLE_SUCCESS: 'Two-factor authentication has been disabled.',
        GENERATE_SUCCESS: 'New recovery codes have been generated. Save them in a safe place.',
        CONFIRM_DISABLE: 'Are you sure you want to disable two-factor authentication?',
        LOGOUT_AFTER_ENABLE: 'You will be logged out automatically after enabling two-factor authentication. Sign in again using the code from your authenticator app.',
      },
    },

    // ------ START ACCOUNTING -----------------------
    BINDLABEL: {
      NAME: 'nameEn',
    },
    SHIFT_CATEGORIES: {
      GENERAL: {
        CREATE: 'Create Shift Category',
        CREATE_SHIFT_CATEGORY: 'Create Shift Category',
        SHIFT_CATEGORIES: 'Shift Categories',
      },
      LABEL: {
        NAME: 'Name',
        START_TIME: 'Start Time',
        END_TIME: 'End Time',
        BRANCH: 'Branch',
        ISACTIVE: 'Status',
        NAME_AR: 'Arabic Name',
        NAME_EN: 'English Name',
      },
      PLACEHOLDER: {
        NAME_AR: 'Enter Arabic name',
        NAME_EN: 'Enter English name',
      },
      VALIDATION: {
        NAME_AR: 'Arabic name is required',
        NAME_EN: 'English name is required',
        START_TIME: 'Start time is required',
        END_TIME: 'End time is required',
      }
    },
    // 
    "PACKAGES": {
      SELECT_MODULES: "Select Modules",
      SELECT_ALL_PAGES: "Select All Pages",
      ENABLE_MODULE: "Enable Module",
      "LABEL": {
        "NAME_EN": "Package Name (English)",
        "NAME": "Package Name",
        "NAME_AR": "Package Name (Arabic)",
        "CODE": "Package Code",
        "TIER_LEVEL": "Tier level",
        "DESC_EN": "Description (English)",
        "DESC_AR": "Description (Arabic)",
        "DESC": "Description",
        "PRICE": "Monthly Price",
        "YEARLY_PRICE": "Yearly Price",
        "DISCOUNT_PERCENT": "Discount (%)",
        "SUBSCRIPTION_TYPE": "Subscription Type",
        "DURATION": "Duration (Days)",
        "ISACTIVE": "Active",
        "RESOURCES": "Resources",
        "RESOURCE_NAME": "Resource Name",
        "RESOURCE_DESC": "Resource Description",
        "ASSIGN": "Assign",
        "FEATURES": "Features",
        "VALUE": "Value"
      },
      "PLACEHOLDER": {
        "NAME_EN": "Enter package name in English",
        "NAME_AR": "Enter package name in Arabic",
        "CODE": "Enter package code",
        "TIER_LEVEL": "Enter tier level (whole number, 0 or greater)",
        "DESC_EN": "Enter description in English",
        "DESC_AR": "Enter description in Arabic",
        "PRICE": "Enter Monthly Price",
        "YEARLY_PRICE": "Enter Yearly Price",
        "DISCOUNT_PERCENT": "Enter discount percentage",
        "DURATION": "Enter Duration",
      },
      "VALIDATION": {
        "NAME_EN": "Package name in English is required",
        "NAME_AR": "Package name in Arabic is required",
        "CODE": "Package code is required",
        "TIER_LEVEL": "Tier level is required and must be a whole number ≥ 0",
        "DESC_EN": "Description in English is required",
        "DESC_AR": "Description in Arabic is required",
        "PRICE": "Monthly Price is required",
        "YEARLY_PRICE": "Yearly Price is required",
        "DISCOUNT_PERCENT": "Discount must be a whole number from 0 to 100",
        "DURATION": "Duration is required",
        "FEATURE_VALUE_INVALID": "Enter a valid whole number.",
        "FEATURE_VALUE_MIN": "Minimum is {{min}}.",
        "FEATURE_VALUE_MAX": "Maximum is {{max}}.",
        "FEATURE_VALUES_INVALID": "Please correct feature values (check min/max limits)."
      },
      "GENERAL": {
        "CREATE": "Create Package",
        "UPDATE": "Update Package",
        "LIST": "List Packages",
        "MAIN": "Packages"
      },
      "BTN": {
        "RESET": "Reset"
      },
      "TITLE": "Package"
    },
    FEATURES: {
      TITLE: 'Features',
      SINGLE: 'Feature',
      UPDATE: 'Update Feature',
      LABEL: {
        NAME: 'Name',
        NAME_AR: 'Name (Arabic)',
        NAME_EN: 'Name (English)',
        DESCRIPTION: 'Description',
        DESCRIPTION_AR: 'Description (Arabic)',
        DESCRIPTION_EN: 'Description (English)',
        FEATURE_TYPE: 'Feature Type',
        CONTROL_TYPE: 'Control Type',
        VALUE: 'Default Value',
        PRICE: 'Price',
        IS_ACTIVE: 'Active',
      },
      PLACEHOLDER: {
        NAME_AR: 'Enter name in Arabic',
        NAME_EN: 'Enter name in English',
        DESCRIPTION_AR: 'Enter description in Arabic',
        DESCRIPTION_EN: 'Enter description in English',
        VALUE: 'Enter default value',
        PRICE: 'Enter price',
      },
      VALIDATION: {
        NAME_AR: 'Arabic name is required',
        NAME_EN: 'English name is required',
        VALUE: 'Value is required',
        PRICE: 'Price is required',
        REQUIRED: 'This field is required',
        WHITESPACE: 'Field cannot be empty or whitespace only',
        MAX_LENGTH: 'Maximum {{max}} characters allowed',
        PRICE_MIN: 'Price must be at least {{min}}',
        PRICE_MAX: 'Price must not exceed {{max}}',
        BOOLEAN_VALUE: 'Value must be true, false, 0, or 1',
        VALUE_HINT: 'Allowed value from {{min}} to {{max}}',
        INVALID: 'Invalid value',
      },
      STATUS: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
      },
      BTN: {
        UPDATE: 'Update',
        CANCEL: 'Cancel',
        BACK: 'Back',
      },
    },
    // -------- START TRAILBALANCE ----------------
    TRAIL_BALANCE: {
      GENERAL: {
        MAIN: 'Trail Balance',
      },
      LABEL: {
        ACCOUNT_NUMBER: "Account Number",
        ACCOUNT_NAME: "Account Name",
        PREV_DEBIT: "Previous Balance Debit",
        PREV_CREDIT: "Previous Balance Credit",
        TRANS_DEBIT: "Transaction Balance Debit",
        TRANS_CREDIT: "Transaction Balance Credit",
        FINAL_DEBIT: "Final Balance Debit",
        FINAL_CREDIT: "Final Balance Credit",
        TOTAL: "Totals",
      }
    },
    // ---------------- END TRAIL BALANCE --------------
    BALANCE_SHEET: {
      GENERAL: {
        MAIN: 'Balance Sheet',
      },
      LABEL: {
        ACCOUNT_NUMBER: "Account Number",
        ACCOUNT_NAME: "Account Name",
        DEBIT: "Debit",
        CREDIT: "Credit",
        TOTAL: "Total",
      }
    },
    ACCOUNTING: {
      GENERAL: {
        MAIN: 'Accounting',
        CHARTACC: 'Chart Of Accounts',
        DAILYJOURNAL: 'Daily Journal',
        ACCOUNTSTAT: 'Simple Account Statement',
        ACCOUNTTYPE: 'Account Type',
        ACCOUNTCATE: 'Account Category',
        JOURNALTYPE: 'Journal Type',
        FINANCIALSTAT: 'Financial Statement',
      },
    },
    CHARTACC: {
      GENERAL: {
        TITLE: 'Chart Of Accounts',
      },
      LABEL: {
        ACCOUNTCODE: 'Account Code',
        ACCOUNTNUMBER: 'Account Number',
        ACCOUNTNAME: 'Account Name',
        NAME_EN: 'Name (English) :',
        NAME_AR: 'Name (Arabic) :',
        ACCONUTURE: 'Account Nature',
        LEVEL: 'Level',
        CATETYPE: 'Account Category Type',
        CURRENCY: 'Currency',
        CATEGORY: 'Account Category',
        ACTIONS: 'Actions',
        PARENT: 'Parent Account',
        ISPARENT: 'Is Parent',
        FINANCIALSTATE: 'Financial Statement Item',
        DESCRIBE_AR: 'Description (Arabic)',
        DESCRIBE_EN: 'Description (English)',
      },
      BTN: {
        NEWACCO: 'New Account',
        CREATE: 'Create Account',
        UPDATE: 'Update Account',
        VIEW: 'View Account',
        CANCEL: 'Cancel',
      },
      PLACEHOLDER: {
        ACCOUNTCODE: 'Enter Account Code',
        ACCOUNTNUMBER: 'Enter Account Number',
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        CURRENCY: 'Select Currency',
        DESCRIBE_AR: 'Enter description (Arabic)',
        DESCRIBE_EN: 'Enter description (English)',
        CATEGORY: 'Select Account Category',
        CATETYPE: 'Select Account Category Type',
        FINANCIALSTATE: 'Select Financial Statement',
        LEVEL: 'Enter Level',
        PARENT: 'Select Parent Account',
        ACCONUTURE: 'Select the Account Nature',
      },
      VALIDATION: {
        ACCOUNTCODE: 'Account Code is required.',
        ACCOUNTNUMBER: 'Account Number is required.',
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        PARENT: 'Parent account is required.',
        ACCONUTURE: 'Account Nature is required',
      },
    },
    DAILYJOURNAL: {
      GENERAL: {
        TITLE: 'Daily Journal',
        ADD_JOURNAL: 'Add Journal',
        VIEW_JOURNAL: 'List Journals',
      },
      LABEL: {
        JOURNALTYPE: 'Journal Type ',
        JOURNALDATE: 'Journal Date',
        REFNO: 'Ref Number',
        DESCRIBE: 'Description',
        NO: 'No',
        ACCOUNT: 'Account',
        DEBIT: 'Debit',
        CREDIT: 'Credit',
        CURRENCY: 'Currency',
        EXCHANGERATE: 'Exchange Rate',
        COMMENT: 'Comment',
        JOURNALTYPE_AR: 'Journal Type',
        JOURNALTYPE_EN: 'Journal Type (English)',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add New Journal',
        ADDLINE: 'Add Line',
        UPDATEITEM: 'Update Journal',
        ADDJOURNAL: 'Add New Journal',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        JOURNALTYPE: 'Select Journal Type',
        ACCOUNT: 'Select Account',
        DESCRIBE: 'Enter Description',
        REFNO: 'Enter Ref No',
        JOURNALDATE: 'Enter Journal Date',
        CURRENCY: 'Select Currency',
        SEARCH: 'Search Journal Entry',
      },
      VALIDATION: {
        JOURNALTYPE: 'Enter Journal Type',
        JOURNALDATE: 'Journal Date',
        DESCRIBE: ' Description',
        REFNO: ' Ref No',
      },
    },
    FINANCIALSTAT: {
      GENERAL: {
        TITLE: 'Simple Account Statement',
        ADD_FINANCIALSTAT: 'Add financial statement',
        VIEW_FINANCIALSTAT: 'List financial statement',
      },
      LABEL: {
        NO: 'NUMBER',
        NAME: 'Name',
        NAME_EN: 'Name (English) :',
        NAME_AR: 'Name (Arabic) :',
        DESC: 'Description',
        DESC_AR: 'Description (Arabic)',
        DESC_EN: 'Description (English)',
        CODE: 'Code',
        NOTE: 'Note',
        PARENT: 'Parent',
        FINANCIALSTATE: 'Statement Item Type',
        EQUATION: 'Equation',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Statement',
        UPDATEITEM: 'Update Statement',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        CODE: 'Enter Code',
        NOTE: 'Enter Note',
        DESC_AR: 'Enter description (Arabic)',
        DESC_EN: 'Enter description (English)',
        PARENT: 'Select Parent',
        FINANCIALSTATE: 'Select Financial Statement Item Type',
        EQUATION: 'Enter Equation',
        SEARCH: 'Search Financial Statement Item',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        DESC_AR: 'Description (Arabic) is required',
        DESC_EN: 'Description (English) is required',
        CODE: 'Code is required',
      },
    },
    ACCOUNTSTAT: {
      GENERAL: {
        TITLE: 'Simple Account Statement',
        ADD_ACCOUNTSTAT: 'Add Account Statements',
        VIEW_ACCOUNTSTAT: 'List Account Statements',
        REPORT: 'Account Statement Report',
        ANALYACCOUNT: 'Analytical account ',
        SUMMERYACCOUNT: 'Summery account ',
      },
      LABEL: {
        ACCOUNTID: 'Account Number',
        ACCOUNNTCODE: 'Account Code',
        NAME: 'Account Name',
        JOURNALTYPE: 'Journal Type',
        DATE: 'Date',
        DESC: 'Description',
        CURRENCY: 'Currency Id',
        CURRENCYCODE: 'Currency Code',
        CURRENCYRATE: 'Currency Rate',
        DEBIT: 'Debit',
        CREDIT: 'Credit',
        TOTALDEBIT: 'Total Debit',
        TOTALCREDIT: 'Total Credit',
        TOTAL: 'Total Balance',
        FROMDATE: 'From Date',
        TODATE: 'To Date',
        STATMENT: 'Statement',
        REPORT_TYPE: 'Report Type',
      },
      BTN: {
        ADDITEM: 'Add Item',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        SEARCH: 'Search Financial Statement Item',
        ACCOUNTID: 'Select Account',
        REPORT_TYPE: 'Select Report Type',
      },
      VALIDATION: {},
    },
    ACCOUNTTYPE: {
      GENERAL: {
        TITLE: 'Account Type',
        ADD_ACCOUNTTYPE: 'Add Account Type',
        VIEW_ACCOUNTTYPE: 'List Account Type',
      },
      LABEL: {
        NO: 'Number',
        NAME_EN: 'Name (English) :',
        NAME_AR: 'Name (Englsih) :',
        DESC_AR: 'Description (English)',
        DESC_EN: 'Description (English)',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Account Type',
        UPDATEITEM: 'Update Account Type',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        DESC_AR: 'Enter description (Arabic)',
        DESC_EN: 'Enter description (English)',
        SEARCH: 'Search Financial Statement Item',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        DESC_AR: 'Description (Arabic) is required',
        DESC_EN: 'Description (English) is required',
      },
    },
    ACCOUNTCATE: {
      GENERAL: {
        TITLE: 'Account Category',
        ADD_ACCOUNTCATE: 'Add Account Category',
        VIEW_ACCOUNTCATE: 'List Account Category',
      },
      LABEL: {
        NO: 'Number',
        NAME_EN: 'Name (English) :',
        NAME_AR: 'Name (English) :',
        LEVEL: 'Level',
        CATETYPE: 'Account Category Type',
        PARENT: 'Parent Account',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Category',
        UPDATEITEM: 'Update Category',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        CATEGORY: 'Select Account Category',
        LEVEL: 'Enter Level',
        PARENT: 'Select Parent Account',
        SEARCH: 'Search Account Category',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        LEVEL: 'Level is required.',
      },
    },
    JOURNALTYPE: {
      GENERAL: {
        TITLE: 'Journal Type',
        ADD_JOURNALTYPE: 'Add Journal Type',
        VIEW_JOURNALTYPE: 'List Journal Type',
      },
      LABEL: {
        NO: 'Number',
        NAME_EN: 'Name (English) ',
        NAME_AR: 'Name ',
        DESC_AR: 'Description',
        DESC_EN: 'Description (English)',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Journal Type',
        UPDATEITEM: 'Update Journal Type',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        DESC_AR: 'Enter description (Arabic)',
        DESC_EN: 'Enter description (English)',
        SEARCH: 'Search jornal type',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
      },
    },
    TAXRETURN: {
      GENERAL: {
        TITLE: 'الأقرار الضريبي',
        TRSTATUS: 'حالة الاقرار الضريبي',
        TSTYPE: 'نوع الاقرار الضريبي',
        VALUESALES: 'ضريبة القيمة المضافة على المبيعات ',
        VALUEPARCHAS: 'ضريبة القيمة المضافة على المشتريات',
      },
      LABEL: {
        NO: 'Number',
        VATNUMBER: 'VAT Number',
        SALESINV: 'Invoice',
        SALESRINV: 'Return',
        PARCHASINV: 'Parchase Invoice',
        PARCHASRINV: 'Parchase Return',
        NETSLAES: 'Net',
        NETVAT: 'Net',
        NETPARCHAS: 'Net Parchase',
        TOTALSALES: 'Total Sales',
        TOTALPARCHASE: 'Total Parchase',
        CORRECTION: 'Correction from previous periods',
        TOTALPREVIOUS: 'VAT carried forward from previous period(s)	',
        TOTALVAT: 'Total VAT due for the tax period:',
        TOTAL: 'Total Amounts',
        FROMDATE: 'From Date ',
        TODATE: 'To Date',
      },
      BTN: {
        ADDITEM: 'Add',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {},
      VALIDATION: {},
    },
    // ------ END ACCOUNTING -----------------------
    // ------ START SALES -----------------------
    SALES: {
      GENERAL: {
        MAIN: 'Sales',
        PRODUCTS: 'Products',
        PRODUCTCATE: 'Products Category',
        INVOICE: 'Sales Invoices',
        RETURNINVOICE: 'Return Invoices',
        REPORT: 'Reports Sales Invoices',
        CUSTOMERS: 'Customers',
      },
    },
    PRICES: {
      GENERAL: {
        TITLE: 'Prices',
        ADD_PRICES: 'Add Prices',
      },
      BTNS: {
        ADDITEM: 'Add Price',
      },
    },
    UNITS_OF_MEASUREMENT: {
      GENERAL: {
        TITLE: 'Units of measurement',
      },

      LABELS: {
        UNIT: 'Unit',
        SIZE: 'Unit Size',
        PRICE: 'Unit Price',
        BARCODE: 'Barcode',
      },
      BTNS: {
        ADDITEM: 'Add New Item',
      },
    },

    BARCODE: {
      GENERAL: {
        TITLEL: 'barcode printing',
      },
    },
    PRODUCTS: {
      PRODUCT_TYPE: {
        Product: 'Product',
        RawMaterial: 'Raw Material',
        Service: 'Service',
        Expenses: 'Expenses',
      },
      GENERAL: {
        TITLE: 'Products',
        CREATE_PRODUCT: 'Create Product',
        UPDATE_PRODUCT: 'Update Product',
        VIEW_PRODUCT: 'View Product',
        BARCODES: 'Products Barcodes',
      },
      LABEL: {
        CODE: 'Code',
        NAME: 'Product Name',
        NAME_EN: 'Name (English) :',
        NAME_AR: 'Name (Arabic) :',
        PROD_TYPE: 'Product Type',
        PROD_CATE: 'Product Category',
        TAX_CATE: 'Tax Category',
        TAXEXCEPTION: 'Tax Exception Reason',
        EXCISETAX: 'Excise Tax Category',
        OPENSTOCK: 'Opening Stock',
        INITCOST: 'Initial Cost',
        REORDER: 'ReOrder Limit',
        DISCOUNTRATE: 'Discount Rate',
        DESC_AR: 'Description (Arabic)',
        DESC_EN: 'Description (English)',
        ISACTIVE: 'Is Active For Sales',
        WITHOUTQUANTITY: 'Allow Sales Without Quantity',
        LESSCOST: 'Allow Selling LessThan Cost',
        UNITS: 'Units',
        QUNANTITY: 'Quantity',
        UNITNAME: 'Unit Name',
        SIZE: 'Size',
        BARCODE: 'Barcodes',
        PRICELEVEL: 'Price Level',
        PRICE: 'Price',
        BRANCH: 'Branch',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Product',
        ADDPRICE: 'Add Price',
        UPDATEITEM: 'Update Product',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        CODE: 'Enter Code',
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        PROD_TYPE: 'Select Product Type',
        PROD_CATE: 'Select Product Category',
        TAX_CATE: 'Select Tax Category',
        TAXEXCEPTION: 'Select Tax Exception Reason',
        EXCISETAX: 'Select Excise Tax Category',
        OPENSTOCK: 'Enter Opening Stock',
        INITCOST: 'Enter Initial Cost',
        REORDER: 'Enter ReOrder Limit',
        DISCOUNTRATE: 'Enter Discount Rate',
        DESC_AR: 'Enter description (Arabic)',
        DESC_EN: 'Enter description (English)',
        UNITNAME: 'Select Unit ',
        PRICE: 'Enter Price Level',
        PRICELEVEL: 'Select Price Level',
        BRANCH: 'Enter Branch',
        SEARCH: 'Search Products',
        UNITS: 'Select Units',
      },
      VALIDATION: {
        CODE: 'Code is required.',
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        UNITNAME: 'Unit is required.',
        SIZE: 'Size is required.',
        PRICELEVEL: 'Price Level is required.',
        PRICE: 'Price is required.',
        UNITS: 'Units is required.',
        TAX_CATE: 'Tax Category is required.',
        INITCOST: 'Initial Cost is required.',
        BARCODE_PRINTING: 'Please choose the unit and enter the quantity',
      },
    },
    PRODUCTCATE: {
      GENERAL: {
        TITLE: 'Products Category',
      },
      LABEL: {
        NO: 'No',
        NAME: 'Category Name',
        NAME_EN: 'Name (English) :',
        NAME_AR: 'Name (Arabic) :',
        PARENT: 'Parent:',
        SALESACCO: 'Sales Account:',
        COSTACCO: 'Cost Account:',
        ISACTIVE: 'Is Active',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Category',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        CODE: 'Enter Code',
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        PARENT: 'Enter Parent:',
        SALESACCO: 'Select Sales Account:',
        COSTACCO: 'Select Cost Account:',
        SEARCH: 'Search Products Category',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
      },
    },
    CUSTOMERS: {
      GENERAL: {
        TITLE: 'Customers',
        SINGLE: 'Customer',
        TITLE_VENDOR: 'Vendors',
        SIGNLE_VENDOR: 'Vendor',
        ADDRESS_TITLE: 'Address Details',
        CREATE_CUSTOMER: 'Create Customer',
        UPDATE_CUSTOMER: 'Update Customer',
        VIEW_CUSTOMER: 'View Customer',
        CREATE_VENDOR: 'Create Vendor',
        UPDATE_VENDOR: 'Update Vendor',
        VIEW_VENDOR: 'View Vendor',
      },
      LABEL: {
        NO: 'NO',
        ACCOUNT_NUMBER: 'Account number',
        TAX_REGISTRATION: 'Tax registration',
        NAME: 'Name',
        ACTIVE_IN_SALE: 'Active In Sale',
        NAME_EN: 'Name (English) :',
        NAME_AR: 'Name (Arabic) :',
        PHONE: 'Phone Number',
        ACCOUNT: 'Account Number',
        PARENTACCOUNT: 'Parent Account',
        ACCOUNT_CATE: 'Account Category',
        EMAIL: 'Email',
        NATIONAL_NO: 'National Number',
        CURRENCY: 'Currency',
        MAXAMOUNT: 'Max Debt Amount',
        VAT_NO: 'Registration Number',
        VAT_NAME: 'VAT Registration Name',
        COMMERCIAL_NO: 'Commercial Record',
        District: 'District',
        COMMERCIAL_NAME: 'Commercial Registration Name',
        NOTE: 'Note',
        ISACTIVE: 'Active In Sale',
        COUNTRY: 'Country',
        CITY: 'City',
        STREET: 'Street',
        ADD_STREET: 'Additional Street',
        BUILDING: 'Building Number',
        PLOTIDENT: 'Plot Identification',
        POSTALCODE: 'Postal Code',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Customer',
        UPDATEITEM: 'Update Customer',
        ADDVENDOR: 'Add Vendor',
        UPDATEVENDOR: 'Update Vendor',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
        CANCEL: 'Cancel',
      },
      PLACEHOLDER: {
        CODE: 'Enter Code',
        NAME_EN: 'Enter name in English',
        NAME_AR: 'Enter name in Arabic',
        PHONE: 'Enter Phone Number',
        ACCOUNT: 'Enter Account Number',
        PARENTACCOUNT: 'Select Parent Account',
        ACCOUNT_CATE: 'Select Account Category',
        District: 'Enter District',
        EMAIL: 'Enter Email',
        NATIONAL_NO: 'Enter National Number',
        CURRENCY: 'Select Currency',
        MAXAMOUNT: 'Enter Max Debt Amount',
        VAT_NO: 'Enter VAT Registration Number',
        VAT_NAME: 'Enter VAT Registration Name',
        COMMERCIAL_NO: 'Enter Commercial Record',
        COMMERCIAL_NAME: 'Enter Commercial Registration Name',
        NOTE: 'Enter Note',
        COUNTRY: 'Select Country',
        CITY: 'Enter City',
        STREET: 'Enter Street',
        ADD_STREET: 'Enter Additional Street',
        BUILDING: 'Enter Building Number',
        PLOTIDENT: 'Enter Plot Identification',
        POSTALCODE: 'Enter Postal Code',
        SEARCH: 'Search Customers',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        PARENTACCOUNT: 'Parent Account is required.',
        PHONE: 'Enter Valid Phone Number',
        EMAIL: 'Enter Valid Email',
        COUNTRY: 'Choose valid country',
        NATIONAL_NO: 'Enter Valid National Number',
        COMMERCIAL_NO: 'Enter Valid Commercial Number',
        VAT_NO: 'Enter Valid VAT Number',
      },
    },
    INVOICE: {
      GENERAL: {
        INVOICE_TITLE: 'Sales Invoices',
        INVOICE_PURCHASE_TITLE: 'Purchases Invoices',
        INVOICE_PAYMENT_TITLE: 'Invoice Payment',
        PYMENT_TITLE: 'Payment info',
        PROD_TITLE: 'Products',
        DESCOUNT_TITLE: 'Discounts Amouns',
        RETURN_TITLE: 'Return Sales Invoices',
        CREATE_RETURN_INVOCE: 'Create Return invoice',
      },
      LABEL: {
        TYPE: 'Invoice type',
        CUSTOMER: 'Customer ',
        VENDOR: 'Vendor',
        PHONE: 'Customer Phone',
        DATE: 'Invoice Date',
        DUEDATE: 'Due Date',
        STORE: 'Store',
        CURRENCY: 'Currency',
        PRICELEVEL: 'Price level',
        PROJECT: 'Project',
        COSTCENTER: 'Cost Center',
        SALESMAN: 'Sales Man',
        BRANCH: 'Branch',
        REFERANCE: 'Referance',
        ADDBY: 'Add By',
        ISCOMMIT: 'Is Committed',
        DOC_TYPE: 'Decument Type',
        CASH: 'Cash',
        GRAND_TOTAL: 'Grand Total',
        PAYMENT_STATUS: 'Payment state',
        CHARGE: 'Charge Amount',
        NO: 'No',
        PRODUCT: 'Product',
        UNITSIZE: 'Unit Size',
        QTY: 'Qty',
        RETURN_QTY: 'Return Qty',
        DESCRIPTION: 'Description',
        PRICE: 'Price',
        COSTAMOUNT: 'Cost Amount',
        DISCONUT: 'Discount',
        TOTALBEFOR_VAT: 'Total Before VAT',
        VAT: 'VAT %',
        VAT_VALUE: 'VAT Value',
        TOTAL: 'Total',
        DISCONUT_AMOUNT: 'Discount Amount',
        PURSHED_AMOUNT: 'Purshed Amount',
        EXCHANGE: 'Exchange Rate',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Item',
        ADDROW: 'Add Row',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
        MORE: 'More',
        CLOSE: 'Close',
        CHOOSE: 'Choose Items',
        CANCEL: 'Cancel',
      },
      PLACEHOLDER: {
        TYPE: 'Select Invoice type',
        CUSTOMER: 'Select Customer ',
        PHONE: 'Enter Customer Phone',
        STORE: 'Select Store',
        CURRENCY: 'Select Currency',
        PRICELEVEL: 'Select Price level',
        PROJECT: 'Select Project',
        COSTCENTER: 'Select Cost Center',
        SALESMAN: 'Enter Sales Man',
        BRANCH: 'Select Branch',
        REFERANCE: 'Enter Referance',
        ADDBY: 'Select an option',
        DOC_TYPE: 'Select Decument Type',
        CASH: 'Select Cash',
        CHARGE: 'Enter Charge Amount',
        ACCOUNT: 'Select Account',
        AMOUNT: 'Amount',
        DESCRIPTION: 'Description',
        DISCONUT_AMOUNT: 'Enter Discount Amount',
        PUSHED_AMOUNT: 'Enter Purshed Amount',
        EXCHANGE: 'Enter Exchange Rate',
        PRODUCT: 'Select Product',
        SEARCH: 'Search Products Category',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
      },
      ERROR: {
        NOQNTITY: 'No Quantity',
      }
    },
    // ------ END SALES -----------------------
    // ------ START MODULE -----------------------
    MODULES: {
      GENERAL: {
        MAIN: 'Modules',
        NEW: 'New Module',
        LIST: 'List Modules',
        PAGETYPE: 'Page Types',
        MODULE_PAGE: 'Module Page',
        PAGE: 'Pages',
        CREATE: 'Create Module',
        UPDATE: 'Update Module',
        CREATE_PAGE: 'Create Module Page',
        CREATE_PAGE_TYPE: 'Create Page Type',
        ACTIONS: 'Select Actions of the page',
      },
      LABEL: {
        CODE: 'Code',
        NAME_EN: 'Name (English) ',
        NAME: 'Name',
        NAME_AR: 'Name (Arabic) ',
        DESC: 'Description',
        DESC_AR: 'Description (Arabic)',
        DESC_EN: 'Description (English)',
        DISPLYORDER: 'Display Order',
        ISACTIVE: 'Is Active',
        RESOURCE: 'Resource Name',
        PAGETYPE: 'Page Type',
        PARENT: 'Parent',
        URL_PATH: 'URL',
        CLASS_NAME: 'Class Name',
        ISVISIBLE: 'Is Visible',
        ISALL: 'Is For All',
        TITLE: 'Title',
        ACTIONS: 'Actions',
        MODULE_TYPE: 'For Whom',
      },
      BTN: {
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
        CLOSE: 'Close',
        UPDATE_BTN: 'Update',
        CREATE_BTN: 'Create',
        NEWPAGE: 'NEW PAGE',
        ADDNEWPAGE: 'Add New Page',
      },
      PLACEHOLDER: {
        CODE: 'Enter Code',
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        DESC_AR: 'Enter description (Arabic)',
        DESC_EN: 'Enter description (English)',
        DISPLYORDER: 'Enter Display Order',
        PAGETYPE: 'Enter Page Type',
        PARENT: 'Enter Parent ID',
        SEARCH: 'Search In Page Type',
        RESOURCE: 'Enter Resource Name',
        URL_PATH: 'Enter URL',
        CLASS_NAME: 'Enter Class Name',
        MODULE_TYPE: 'Select For Whom',
      },
      VALIDATION: {
        CODE: 'Code is required.',
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        PAGETYPE: 'Page Type is required.',
        MODULE_TYPE: 'For Whom is required.',
      },
      MODULE_TYPE: {
        FOR_ROOT_TENANT: 'For Super admin',
        FOR_OTHER: 'For ERP',
        FOR_ALL: 'For All',
      },
    },
    // ------ END MODULE -----------------------
    // TODO: Purchases - Stock - Assets - Manufacturing - Quality - Projects - HR - Support - CRM
    // ------ START USERS -----------------------
    USERS: {
      GENERAL: {
        TITLE: 'Users',
        PROFILE: 'User Profile',
        DETAILS: 'Details',
        ADD_USER: 'Add User',
      },
      LABEL: {
        FRISTNAME: 'First Name',
        FIRST_NAME: 'First Name',
        LASTNAME: 'Last Name',
        LAST_NAME: 'Last Name',
        FULLNAME: 'Full Name',
        COMPANY: 'Company Name',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        PHONE: 'Phone Number',
        USERNAME: 'User Name',
        USER_NAME: 'User Name',
        EMAIL: 'Email',
        ROLES: 'Roles',
        ISACTIVE: 'Is Active',
        IS_ACTIVE: 'Is Active',
        ACTIONS: 'Actions',
        LAST_LOGIN: 'Last Login',
      },
      BTN: {
        SAVE: 'Save',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        FRISTNAME: 'Enter First Name',
        LASTNAME: 'Enter Last Name',
        COMPANY: 'Enter Company Name',
        PHONE: 'Enter Phone Number',
        USERNAME: 'Enter User Name',
        EMAIL: 'Enter Email',
        SEARCH: 'Search in users list',
        ROLES: 'Select Role',
        PASSWORD: 'Enter Password',
        CONFIRM_PASSWORD: 'Enter Password again',
      },
      VALIDATION: {
        USER: 'User is required.',
        ROLE: 'Role is required.',
        FRISTNAME: 'First Name is required.',
        LASTNAME: 'Last Name is required.',
        PHONE: 'Phone Number is required.',
        USERNAME: 'User Name is required.',
        EMAIL: 'Email is required.',
        ROLES: 'Role is required.',
        COMPANY: 'Company Name is required',
        PASSWORD:
          'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one number or special character.',
        CONFIRM_PASSWORD: 'Passwords must match.',
      },
    },
    // ------ END USERS -----------------------
    // ------ START LOGIN_HISTORY -----------------------
    LOGIN_HISTORY: {
      GENERAL: {
        TITLE: 'Login History',
      },
      LABEL: {
        FULLNAME: 'Full Name',
        USERNAME: 'Username',
        EMAIL: 'Email',
        PHONE: 'Phone Number',
        IS_ACTIVE: 'Is Active',
        LAST_LOGIN: 'Last Login',
        LOGIN_PROVIDER: 'Login Provider',
        STATUS: 'Status',
        FAILURE_REASON: 'Failure Reason',
      },
      STATUS: {
        SUCCESS: 'Success',
        FAILED: 'Failed',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
      },
    },
    // ------ END LOGIN_HISTORY -----------------------
    // ------ START AUDIT_TRAIL -----------------------
    AUDIT_TRAIL: {
      GENERAL: {
        TITLE: 'Audit Trail',
      },
      LABEL: {
        ID: 'ID',
        TYPE: 'Type',
        TABLE_NAME: 'Table Name',
        DATE_TIME: 'Date & Time',
        USER_ID: 'User ID',
        USER_NAME: 'User Name',
        EMAIL: 'Email',
        AFFECTED_COLUMNS: 'Affected Columns',
        PRIMARY_KEY: 'Primary Key',
        COLUMNS: 'Columns',
        ACTIONS: 'Actions',
      },
      TYPE: {
        CREATE: 'Create',
        UPDATE: 'Update',
        DELETE: 'Delete',
      },
      MODAL: {
        TITLE: 'Audit Trail Details',
        BASIC_INFORMATION: 'Basic Information',
        OLD_VALUES: 'Old Values',
        NEW_VALUES: 'New Values',
      },
      BTN: {
        VIEW_DETAILS: 'View Details',
        CLOSE: 'Close',
      },
    },
    // ------ END AUDIT_TRAIL -----------------------
    // ------ START SETTINGS -----------------------
    SETTINGS: {
      GENERAL: {
        MAIN: 'Settings',
        CURRENCIES: 'Currencies',
        COMPANIES: 'Companies',
        STORES: 'Stores',
        UNITS: 'Units',
        PRICELEVEL: 'Price Level',
        TAXCATE: 'Tax Category',
        ROLE: 'Role',
        PERMISSION: 'Permission Role',
      },
    },
    // ------ END SETTINGS -----------------------
    // ------ START CURRENCIES -----------------------
    CURRENCIES: {
      GENERAL: {
        TITLE: 'Currency',
      },
      LABEL: {
        NAME_EN: 'Name (English) ',
        NAME_AR: 'Name (Arabic) ',
        DESC_AR: 'Description (Arabic)',
        DESC_EN: 'Description (English)',
        EXCHANGERATE: 'Exchange Rate',
        SYMBOL: 'Symbol',
        ISOCURRENCY: 'Iso Currency Code',
        PERCISION: 'Precision',
        ISDEFAULT: 'Is Default',
        ACTIONS: 'Actions',
      },
      BTN: {
        CREATE: 'Create Currency',
        UPDATE: 'Update Currency',
        SAVE: 'Save',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        DESC_AR: 'Enter description (Arabic)',
        DESC_EN: 'Enter description (English)',
        EXCHANGERATE: 'Enter Exchange Rate',
        SYMBOL: 'Enter Symbol',
        ISOCURRENCY: 'Ener Iso Currency Code',
        PERCISION: 'Enter Precision',
        SEARCH: 'Search in Currency list',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        EXCHANGERATE: 'Exchange Rate is required.',
        SYMBOL: 'Symbol is required.',
        ISOCURRENCY: 'Iso Currency Code is required.',
        PERCISION: 'Precision is required.',
      },
    },
    // ------ END CURRENCIES -----------------------
    BRANCHES: {
      LABEL: {
        NAME_AR: "Arabic Name",
        NAME_EN: "English Name",
        PARENT: "Parent Branch",
        COUNTRY_CODE: "Country Code",
        CURRENCY: "Currency",
        TAX_ACCOUNT: "Tax Account",
        PHONE: "Phone",
        EMAIL: "Email",
        VAT_REGISTRATION_NUMBER: "VAT Registration Number",
        VAT_REGISTRATION_NAME: "VAT Registration Name",
        COMMERCIAL_REGISTRATION_NUMBER: "Commercial Registration Number",
        COMMERCIAL_REGISTRATION_NAME: "Commercial Registration Name",
        REGION_NAME: "Region / State",
        CITY_NAME: "City",
        STREET_NAME: "Street Name",
        ADDITIONAL_STREET_NAME: "Additional Street Name",
        CITY_SUBDIVISION_NAME: "City Subdivision",
        POSTAL_CODE: "Postal Code",
        BUILDING_NUMBER: "Building Number",
        NOTE: "Note",
        PHOTO: "Photo",
        DROP_IMAGE: "Drop image here",
        IMAGE_COUNT: "Only one image allowed",
        REPORT_HEADER_IMAGE: "Report Header Image",
        REPORT_FOOTER_IMAGE: "Report Footer Image"
      },
      PLACEHOLDER: {
        NAME_AR: "Enter Arabic name",
        NAME_EN: "Enter English name",
        PARENT: "Enter parent branch",
        COUNTRY_CODE: "Select country code",
        CURRENCY: "Select currency",
        TAX_ACCOUNT: "Enter tax account",
        PHONE: "Enter phone number",
        EMAIL: "Enter email address",
        VAT_REGISTRATION_NUMBER: "Enter VAT registration number",
        VAT_REGISTRATION_NAME: "Enter VAT registration name",
        COMMERCIAL_REGISTRATION_NUMBER: "Enter commercial registration number",
        COMMERCIAL_REGISTRATION_NAME: "Enter commercial registration name",
        REGION_NAME: "Enter region or state",
        CITY_NAME: "Enter city name",
        STREET_NAME: "Enter street name",
        ADDITIONAL_STREET_NAME: "Enter additional street name",
        CITY_SUBDIVISION_NAME: "Enter city subdivision",
        POSTAL_CODE: "Enter postal code",
        BUILDING_NUMBER: "Enter building number",
        NOTE: "Enter note"
      },
      VALIDATION: {
        NAME_AR: "Arabic name is required and should be max 100 characters",
        NAME_EN: "English name should be max 100 characters",
        COUNTRY_CODE: "Country code is invalid",
        CURRENCY: "Invalid currency selection",
        PHONE: "Phone number must be between 10 and 14 characters",
        EMAIL: "Email address is invalid"
      },
      BTN: {
        CREATE: "Create Branch",
        UPDATE: "Update Branch",
        RESET: "Reset"
      },
      GENERAL: {
        TITLE: "Branch Details",
        VIEW_BRANCHES: "List Branches"
      }
    },
    // ------ START COMPANIES -----------------------
    COMPANIES: {
      GENERAL: {
        TITLE: 'Company',
        LIST: 'List companies',
      },
      LABEL: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        COUNTRY_CODE: 'Country Code',
        CURRENCY: 'Currency',
        NOTE: 'Note',
        PHOTO: 'Photo',
        ACTIONS: 'Actions',
        DROP_IMAGE: 'drop image here or click to upload.',
        IMAGE_COUNT: 'Upload up to 1 image',
      },
      BTN: {
        CREATE: 'Create Company',
        UPDATE: 'Update Company',
        SAVE: 'Save',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        COUNTRY_CODE: 'Select Country Code',
        CURRENCY: 'Select Currency',
        NOTE: 'Enter your note here',
        SEARCH: 'Search in Company list',
      },
      VALIDATION: {
        NAME_AR: ' Name (ARABIC) is required.',
      },
    },
    // ------ END COMPANIES -----------------------
    STORE: {
      GENERAL: {
        TITLE: 'Store',
        ADD_STORE: 'Add New Store',
        VIEW_STORES: 'List Stores',
      },
      LABEL: {
        NAME: 'Store Name',
        NAME_EN: 'English Name',
        NAME_AR: 'Arabic Name',
        PARENT: 'Parent Account',
        SALES_ACCOUNT: 'Sales Account',
        COST_ACCOUNT: 'Cost Account',
        STORE_ACCOUNT: 'Store Account',
        DISCOUNT_ACCOUNT: 'Discount Account',
        TAX_ACCOUNT: 'Tax Account',
        NOTE: 'Notes',
      },
      PLACEHOLDER: {

        NAME_EN: 'Enter English Name',
        NAME_AR: 'Enter Arabic Name',
        PARENT: 'Enter Parent Account',
        SALES_ACCOUNT: 'Enter Sales Account',
        COST_ACCOUNT: 'Enter Cost Account',
        STORE_ACCOUNT: 'Enter Store Account',
        DISCOUNT_ACCOUNT: 'Enter Discount Account',
        TAX_ACCOUNT: 'Enter Tax Account',
        NOTE: 'Enter your notes',
        SEARCH: 'Search in stores list',
      },
      VALIDATION: {
        NAME_AR: 'Arabic Name is required.',
      },
      BTN: {
        SAVE: 'Save',
        RESET: 'Reset',
        SEARCH: 'Search',
        ADDITEM: 'Add Store',
        UPDATEITEM: 'Update Store',
        FILTER: 'Filter',
      },
    },
    // ------ START UNITS -----------------------
    UNITS: {
      GENERAL: {
        TITLE: 'Units',
      },
      LABEL: {
        NAME_EN: 'Name (English) ',
        NAME_AR: 'Name (Arabic) ',
        DEFAULTSIZE: 'Default Size',
        CODE: 'Code',
        NAME: 'Name',
        NO: 'No',
        ACTIONS: 'Actions',
      },
      BTN: {
        ADDITEM: 'Add Unit',
        UPDATEITEM: 'Update Unit',
        SAVE: 'Save',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        DEFAULTSIZE: 'Enter Default Size',
        SEARCH: 'Search in Unit list',
        CODE: 'Enter Code Like KG, CM ..etc',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
        DEFAULTSIZE: 'Default Size is required.',
        CODE: 'Enter Code',
      },
    },
    // ------ END UNITS -----------------------
    // ------ START TAXCATE -----------------------
    TAXCATE: {
      GENERAL: {
        TITLE: 'Tax Category',
        TAXEXCEPTION: 'Tax Exception Reasons',
      },
      LABEL: {
        CODE: 'Code',
        TAXRATE: 'Tax Rate',
        DESC_AR: 'Description (Arabic)',
        DESC_EN: 'Description (English)',
        NO: 'No',
        TAXCATE: 'Tax Category',
        EXCEPTION_REASON: 'Tax Exception Reason',
        EXCISE: 'Excise Tax Category',
      },
      BTN: {
        ADDROW: 'Add Row',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        TAXRATE: 'Enter Tax Rate',
        DESC_AR: 'Enter description (Arabic)',
        DESC_EN: 'Enter description (English)',
        SEARCH: 'Search in Tax Category list',
        TAXCATE: 'Select Tax Category',
      },
      VALIDATION: {
        CODE: 'Code is required.',
        TAXRATE: 'Tax Rate is required.',
        DESC_EN: ' Description (English) is required.',
        DESC_AR: 'Description (Arabic) is required.',
      },
    },
    // ------ END TAXCATE -----------------------
    // ------ START PRICELEVEL -----------------------
    PRICELEVEL: {
      GENERAL: {
        TITLE: 'Price Level',
      },
      LABEL: {
        NAME_EN: 'Name (English) ',
        NAME_AR: 'Name (Arabic) ',
        STARTDATE: 'Start Date ',
        EXPIRYDATE: 'Expiry Date ',
        BASEDON: 'Based On',
        PRICETYPE: 'Price Type',
        DEFAULT: 'Default Price',
        MIN: 'Min Price',
        MAX: 'Max Price',
        WHOLESALE: 'Whole sale Price',
        DELIVERY: ' Delivery Price',
        INLINESTORE: 'Online Store Price',
        DESEDONDATE: 'Based On Date',
        WEEKTYINTERVAL: 'Weekly Interval',
        MONTHLYINTERVAL: 'Monthly Interval',
        YEARLYINTERVAL: 'Yearly Interval',
        BASEDONRATE: 'Based On Rate',
        ISACTIVE: 'Is Active',
      },
      BTN: {
        ADDROW: 'Add Row',
        RESET: 'Reset',
        SEARCH: 'Search',
        FILTER: 'Filter',
      },
      PLACEHOLDER: {
        NAME_EN: 'Enter Name (English)',
        NAME_AR: 'Enter Name (Arabic)',
        SEARCH: 'Search in Price Level List',
      },
      VALIDATION: {
        NAME_EN: ' Name (English) is required.',
        NAME_AR: 'Name (Arabic) is required.',
      },
    },
    // ------ END PRICELEVEL -----------------------
    // ------ START VERSIONS -----------------------
    VERSIONS: {
      GENERAL: {
        MAIN: 'Versions Management',
        CREATE: 'Create Version',
        UPDATE: 'Update Version',
        VIEW: 'View Version',
        LIST: 'Versions',
        ADD_NEW_VERSION: 'Add New Version',
        VERSIONS: 'Versions',
        FEATURES: 'Features',
        NO_VERSIONS: 'No versions found',
        ALL: 'All',
        ACTIVE: 'Active',
        NOT_ACTIVE: 'Not Active',
      },
      LABEL: {
        VERSION_NUMBER: 'Version Number',
        TAG: 'Tag',
        NAME_AR: 'Name (Arabic)',
        NAME_EN: 'Name (English)',
        DESCRIPTION_AR: 'Description (Arabic)',
        DESCRIPTION_EN: 'Description (English)',
        RELEASE_DATE: 'Release Date',
        VERSION_TYPE: 'Version Type',
        STATUS: 'Status',
        PLATFORM_TYPE: 'Supported Platforms',
        IS_ACTIVE: 'Is Active',
        RELEASE_NOTES_AR: 'Release Notes (Arabic)',
        RELEASE_NOTES_EN: 'Release Notes (English)',
        FEATURES: 'Included Features',
        FEATURE_NAME_AR: 'Feature Name (Arabic)',
        FEATURE_NAME_EN: 'Feature Name (English)',
        FEATURE_DESCRIPTION_AR: 'Feature Description (Arabic)',
        FEATURE_DESCRIPTION_EN: 'Feature Description (English)',
        FEATURE_STATUS: 'Feature Status',
        FEATURE_CATEGORY: 'Feature Category',
        FEATURE_PLATFORM: 'Feature Platform',
      },
      PLACEHOLDER: {
        VERSION_NUMBER: 'Enter version number',
        TAG: 'Enter tag',
        NAME_AR: 'Enter name (Arabic)',
        NAME_EN: 'Enter name (English)',
        DESCRIPTION_AR: 'Enter description (Arabic)',
        DESCRIPTION_EN: 'Enter description (English)',
        RELEASE_DATE: 'Select release date',
        VERSION_TYPE: 'Select version type',
        STATUS: 'Select status',
        PLATFORM_TYPE: 'Select platform type',
        RELEASE_NOTES_AR: 'Enter release notes (Arabic)',
        RELEASE_NOTES_EN: 'Enter release notes (English)',
        FEATURE_NAME_AR: 'Enter feature name (Arabic)',
        FEATURE_NAME_EN: 'Enter feature name (English)',
        FEATURE_DESCRIPTION_AR: 'Enter feature description (Arabic)',
        FEATURE_DESCRIPTION_EN: 'Enter feature description (English)',
        FEATURE_STATUS: 'Select feature status',
        FEATURE_CATEGORY: 'Select feature category',
        FEATURE_PLATFORM: 'Select feature platform',
      },
      VALIDATION: {
        VERSION_NUMBER: 'Version number is required',
        TAG: 'Tag is required',
        NAME_AR: 'Name (Arabic) is required',
        NAME_EN: 'Name (English) is required',
        RELEASE_DATE: 'Release date is required',
        VERSION_TYPE: 'Version type is required',
        STATUS: 'Status is required',
        PLATFORM_TYPE: 'Platform type is required',
        FEATURE_NAME_AR: 'Feature name (Arabic) is required',
        FEATURE_NAME_EN: 'Feature name (English) is required',
        FEATURE_STATUS: 'Feature status is required',
        FEATURE_CATEGORY: 'Feature category is required',
        FEATURE_PLATFORM: 'Feature platform is required',
      },
      BTN: {
        ADD_VERSION: 'Add Version',
        CREATE: 'Create',
        UPDATE: 'Update',
        RESET: 'Reset',
        CANCEL: 'Cancel',
        VIEW_DETAILS: 'View Details',
        EDIT: 'Edit',
        ADD_FEATURE: 'Add Feature',
        DELETE_FEATURE: 'Delete Feature',
      },
      STATUS: {
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In Progress',
        PLANNED: 'Planned',
        DRAFT: 'Draft',
        IN_REVIEW: 'In Review',
        APPROVED: 'Approved',
        RELEASED: 'Released',
        ARCHIVED: 'Archived',
      },
      VERSION_TYPE: {
        MAJOR: 'Major',
        MINOR: 'Minor',
        PATCH: 'Patch',
        HOTFIX: 'Hotfix',
      },
      PLATFORM_TYPE: {
        WEB: 'Web',
        MOBILE: 'Mobile',
        DESKTOP: 'Desktop',
        API: 'API',
        ALL: 'All',
        WEB_MOBILE: 'Web, Mobile',
        WEB_MOBILE_DESKTOP: 'Web, Mobile, Desktop',
      },
      FEATURE_STATUS: {
        NEW: 'New',
        ENHANCED: 'Enhanced',
        FIXED: 'Fixed',
        DEPRECATED: 'Deprecated',
      },
      FEATURE_CATEGORY: {
        NEW_FEATURE: 'New Feature',
        BUG_FIX: 'Bug Fix',
        ENHANCEMENT: 'Enhancement',
        SECURITY: 'Security',
        PERFORMANCE: 'Performance',
        DOCUMENTATION: 'Documentation',
      },
      MODAL: {
        TITLE: 'Version Details',
        DESCRIPTION: 'Description',
        BASIC_INFORMATION: 'Basic Information',
        INCLUDED_FEATURES: 'Included Features',
      },
    },
    // ------ END VERSIONS -----------------------
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
  },
};
